<template>
  <BaseElFormItem label="預約時段預覽">
    <div class="flex flex-col" style="gap: 8px;">
      <p
        class="font-medium text-gray-60 text-sub"
        style="line-height: 16px;"
      >
        以下為根據您的設定，系統產生每隔 {{ formData.timeUnit }} 分鐘的預約時間預覽。
      </p>
      <GrayBlockContainer>
        <div class="flex items-center" style="gap: 8px">
          <div class="flex flex-wrap" style="gap: 8px">
            <div v-for="period in displayPeriods" :key="period" class="period-item">
              {{ period }}
            </div>
            <p class="text-normal relative" style="line-height: 16px; top: 5px">~</p>
          </div>
        </div>
      </GrayBlockContainer>
      <GrayBlockContainer>
        <div class="flex items-center" style="gap: 8px">
          <div class="flex-shrink-0">
            <MaterialIcon color="var(--primary-100)">
              error_outline
            </MaterialIcon>
          </div>
          <p class="text-sub" style="line-height: 20px;">此設定決定的是預約時間的基本規則，顧客實際能預約的時間還會受到營業時間、服務人員排班和設備可用性的影響。</p>
        </div>
      </GrayBlockContainer>
    </div>
  </BaseElFormItem>
</template>

<script>
import GrayBlockContainer from '@/components/Container/GrayBlockContainer.vue'
import { generateFormatPeriod } from '@/utils/time'
import { toNumber, get } from 'lodash'

import { computed, defineComponent, inject } from 'vue'
export default defineComponent({
  name: 'PeriodOffsetPreviewBlock',
  components: {
    GrayBlockContainer,
  },
  setup (props, { emit }) {
    const formData = inject('formData')

    const displayPeriods = computed(() => {
      const timeUnit = get(formData, 'timeUnit') || 30
      const timeUnitOffset = get(formData, 'timeUnitOffset') || 0

      const periods = generateFormatPeriod({
        gap: toNumber(timeUnit),
        offset: toNumber(timeUnitOffset),
      })

      //   TOFIX 如果 20:30 會導致生成錯誤
      return periods.splice(0, 9)
    })

    return {
      formData,
      displayPeriods,
    }
  },
})
</script>

<style lang="postcss" scoped>
.period-item {
    @apply flex-shrink-0 py-[4px] px-[8px] text-sm leading-[16px];
    @apply text-primary-100 bg-white rounded-[6px];
    @apply border border-solid border-primary-100;
}
</style>
